import { render, staticRenderFns } from "./StarterHeader.vue?vue&type=template&id=7222674a&"
import script from "./StarterHeader.vue?vue&type=script&lang=js&"
export * from "./StarterHeader.vue?vue&type=script&lang=js&"
import style0 from "./StarterHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports